import { render } from "./SpinPointerComponent.vue?vue&type=template&id=9b9b9ba2&scoped=true"
import script from "./SpinPointerComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SpinPointerComponent.vue?vue&type=script&setup=true&lang=js"

import "./SpinPointerComponent.vue?vue&type=style&index=0&id=9b9b9ba2&scoped=true&lang=css"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b9b9ba2"],['__file',"src/views/me/SpinPointerComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9b9b9ba2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9b9b9ba2', __exports__)) {
    console.log('reload')
    api.reload('9b9b9ba2', __exports__)
  }
  
  module.hot.accept("./SpinPointerComponent.vue?vue&type=template&id=9b9b9ba2&scoped=true", () => {
    console.log('re-render')
    api.rerender('9b9b9ba2', render)
  })

}


export default __exports__